// extracted by mini-css-extract-plugin
export default {"dateCard":"date-card_dateCard__VEBzx"};